import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as toast from "../../../utils/makeToast";
import { useDispatch } from "react-redux";
import Icon_L from "../../../assets/images/Icon_L.svg";
import { IBankBranch } from "../../../models/IEnums.model";
import { setAccountOpeningStep } from "../../../redux/accountOpening";
import { baseUrl } from "../../../utils/baseUrl";
import uploadArrow from "../../../assets/images/upload-arrow.svg";
import pen from "../../../assets/images/pen.svg";
import camera from "../../../assets/images/camera.svg";
import axios from "axios";
import { getLocalStorageItem } from "../../../utils/localStorage";
import closeIcon from "../../../assets/images/close-icon.svg";
import { trimImageURI } from "../../../utils/imageUpload";
import SignatureCanvas from "react-signature-canvas";
import { links } from "../../../utils/constants";
import DOMPurify from "dompurify";
import { encryptRequest } from "../../../utils/encryption";

function ExUploadDocumentJointCurrentDialog(props: any) {
  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues: {
      smsAlertValueAddedService: "",
      emailAlertValueAddedService: "",
      debitCardValueAddedService: "",
      terms: "",
      debitCardType: "master_card",
    },
    onSubmit: (values) => {
      uploadDcouments(values);
    },
  });

  const [updating, setUpdating] = useState(false);

  const [signatureImageUrl, setSignatureImageUrl] = useState("");
  const [pictureImageUrl, setPictureImageUrl] = useState("");
  const [frontPageImageUrl, setFrontPageImageUrl] = useState("");

  const [settingSignatureImage, setSettingSignatureImage] =
    useState<boolean>(false);
  const [settingPictureImage, setSettingPictureImage] =
    useState<boolean>(false);
  const [settingFrontPageImage, setSettingFrontPageImage] =
    useState<boolean>(false);

  const [userDetails, setUserDetails] = useState(
    getLocalStorageItem("userDetails")
  );
  const [userExistingDetails, setUserExistingDetails] = useState<any>();
  const [bvnValidationData, setBvnValidationData] = useState(
    getLocalStorageItem("bvnValidationData")
  );

  const [showSignaturePad, setShowSignaturePad] = useState<boolean>(false);
  const [signatureName, setSignatureName] = useState<string>("");

  const goToStep = (step: any) => {
    dispatch(setAccountOpeningStep(step));
  };

  let fileUploadObj: any;

  const uploadDcouments = (values: any) => {
    let uploadDocumentPayload = {
      id: getLocalStorageItem("uploadId"),
      signatureUrl: signatureImageUrl,
      imageUrl: pictureImageUrl,
      frontPageIdUrl: frontPageImageUrl,
      smsAlertValueAddedService: true,
      emailAlertValueAddedService: true,
      debitCardValueAddedService:
        typeof values.debitCardValueAddedService == "boolean"
          ? !values.debitCardValueAddedService
          : true,

      accountTypecode: localStorage.getItem("altFinanceGlCode"),
      accountTypeName: localStorage.getItem("altFinanceAccountType"),

      occupationName: "",
      isFlagged: bvnValidationData.isFlagged,

      branchOfDomiciliation: userExistingDetails?.branchOfDomiciliation || 1,
    };
    
    if (!values.terms) {
      toast.errorToast("Please accept terms and conditions");
      return;
    }
    // return
    setUpdating(true);
    axios
      .post(
        `${baseUrl}CurrentAccount/CurrentDocumentUpload`,
        uploadDocumentPayload
      )
      .then((response) => {
        
        setUpdating(false);
        localStorage.setItem(
          "generatedAccountNumber",
          response?.data?.obj?.accountNo
        );
        dispatch(setAccountOpeningStep("account-opening-success"));
      })
      .catch((err) => {
        
        setUpdating(false);
        toast.errorToast(
          err?.response?.data?.title
            ? err?.response?.data?.title
            : err?.response?.data?.message
        );
      });
  };

  const getExistingDetails = () => {
    axios
      .get(
        `${baseUrl}CurrentAccount/CurrentExistingDetails?Bvn=${encryptRequest(
          userDetails.bvn
        )}`
      )
      .then((response) => {
        setUserExistingDetails(response?.data);
      })
      .catch((err) => {
        
      });
  };

  useEffect(() => {
    getExistingDetails();
  }, []);

  const uploadImage = (payload: any, type: string) => {
    
    if (type === "signature") {
      setSettingSignatureImage(true);
    }
    if (type === "frontPageId") {
      setSettingFrontPageImage(true);
    }
    if (type === "image") {
      setSettingPictureImage(true);
    }
    // return
    axios
      .post(`${baseUrl}Authentication/UploadFile`, payload)
      .then((response) => {
        
        if (type == "signature") {
          
          setSignatureImageUrl(response.data?.id);
          setSettingSignatureImage(false);
        } else if (type == "frontPageId") {
          
          setFrontPageImageUrl(response.data?.id);
          setSettingFrontPageImage(false);
        } else if (type == "image") {
          
          setPictureImageUrl(response.data?.id);
          setSettingPictureImage(false);
        }
      })
      .catch((err) => {
        
        toast.errorToast(
          err?.response?.data?.title
            ? err?.response?.data?.title
            : err?.response?.data?.message
        );
      });
  };

  const handleSubmit = (type: string) => {
    uploadImage(fileUploadObj, type);
  };

  const convertToBase64 = (file: any) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        let fileReaderResult = fileReader.result?.toString();
        if (
          fileReader.result
            ?.toString()
            .substring(0, 25)
            .split("/")[1]
            .split(";")[0] === "png" ||
          fileReader.result
            ?.toString()
            .substring(0, 25)
            .split("/")[1]
            .split(";")[0] === "jpg" ||
          fileReader.result
            ?.toString()
            .substring(0, 25)
            .split("/")[1]
            .split(";")[0] === "pdf"
        ) {
          return resolve(fileReaderResult?.substring(22));
        } else if (
          fileReader.result
            ?.toString()
            .substring(0, 25)
            .split("/")[1]
            .split(";")[0] === "jpeg"
        ) {
          return resolve(fileReaderResult?.substring(23));
        }
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const handleFileUpload = async (e: any, type: string) => {
    const file = e.target.files[0];
    let base64: any;
    const allowedFileTypes = ["image/jpeg", "image/png", "application/pdf"];

    // Validate file type
    if (!allowedFileTypes.includes(file.type)) {
      

      toast.errorToast("Only image (JPEG, PNG) or PDF files are allowed.");
      return;
    }

    convertToBase64(file).then((res) => {
      base64 = res;
      fileUploadObj = {
        postedFilebase64: res,
        documentName: type,
        filetype: file.type.split("/")[1],
      };
      handleSubmit(type);
    });
  };

  const selectYesNo = (val: any) => {
    formik.values.debitCardValueAddedService = "";
    formik.values.emailAlertValueAddedService = "";
    formik.values.smsAlertValueAddedService = "";
  };

  const clearImage = (type: any) => {
    if (type === "signature") {
      setSignatureImageUrl("");
    }
    if (type === "image") {
      setPictureImageUrl("");
    }
    if (type === "front-page") {
      setFrontPageImageUrl("");
    }
  };

  let sigPad: any = {};

  const toggleSignaturePad = (type: string, value: boolean) => {
    setSignatureName(type);
    setShowSignaturePad(value);
  };

  const closeSignaturePad = () => {
    clearSignaturePad();
    setShowSignaturePad(false);
  };

  const clearSignaturePad = () => {
    sigPad.clear();
  };

  const uploadSignaturePadSketch = () => {
    let res = trimImageURI(sigPad.getTrimmedCanvas().toDataURL("image/png"));
    fileUploadObj = {
      postedFilebase64: res,
      documentName: signatureName,
      filetype: "png",
    };
    handleSubmit(signatureName);
    closeSignaturePad();
  };

  return (
    <div>
      {showSignaturePad && (
        <div className="pt-4 pb-4 signature-pad-div">
          <p className="text-center">Draw your signature inside the box</p>
          <div className="signature-pad-inner-div">
            <SignatureCanvas
              penColor="black"
              ref={(ref) => {
                sigPad = ref;
              }}
              canvasProps={{ width: 300, height: 200, className: "sigCanvas" }}
            />
          </div>
          <div className="d-flex justify-content-center mt-4">
            <button
              className="signature-cancel-btn"
              onClick={closeSignaturePad}
            >
              Close
            </button>
            <button className="signature-clear-btn" onClick={clearSignaturePad}>
              Clear
            </button>
            <button
              className="signature-upload-btn"
              onClick={uploadSignaturePadSketch}
            >
              Upload
            </button>
          </div>
        </div>
      )}

      <form onSubmit={formik.handleSubmit}>
        <div className=" card-form pl-1 pr-1 ">
          <div className="card-body">
            <h4 className="card-title text-center pl-3 mt-5">
              Document upload
            </h4>
            <p className="text-center">
              <small>
                The file format should be JPEG, PNG or PDF (max size:2mb)
              </small>
            </p>
            <div className="bvn_val mb-3 justify-content-start" id="fader">
              <img src={Icon_L} alt="" style={{ marginRight: "20px" }} />
              <small className="text-danger font-weight-bold pl-4">
                <b>Do you have any pending documents to upload?</b>
              </small>

              <ul
                className="nav nav-pills documents-tab pt-2 ml-5 pl-5 nav-fill"
                id="pills-tab"
                role="tablist"
              >
                <li className="nav-item" role="presentation">
                  <a
                    className="nav-link active text-danger"
                    id="pills-yes-tab"
                    data-toggle="pill"
                    href="#pills-yes"
                    role="tab"
                    aria-controls="pills-yes"
                    aria-selected="true"
                    onClick={() => selectYesNo(true)}
                  >
                    Yes
                  </a>
                </li>
                <li className="nav-item" role="presentation">
                  <a
                    className="nav-link text-danger"
                    id="pills-no-tab"
                    data-toggle="pill"
                    href="#pills-no"
                    role="tab"
                    aria-controls="pills-no"
                    aria-selected="false"
                    onClick={() => selectYesNo(false)}
                  >
                    No
                  </a>
                </li>
              </ul>
            </div>
            <div className="form-group">
              <div className="tab-content" id="pills-tabContent">
                <div
                  className="tab-pane fade show active"
                  id="pills-yes"
                  role="tabpanel"
                  aria-labelledby="pills-yes-tab"
                >
                  <div className="row mr-3">
                    {!pictureImageUrl ? (
                      <div className="col-lg-6">
                        <div className="col-md-6">
                          <label
                            htmlFor="firstname"
                            className="label_text2 d-inline text-nowrap"
                          >
                            Upload Passport Photo
                          </label>
                          <label
                            className="cursor-pointer"
                            htmlFor="inputTagImage"
                          >
                            <div className="pic_upload d-flex justify-content-between pt-3 pr-3 px-2">
                              {settingPictureImage ? (
                                <div className="center-v">
                                  <div
                                    className="spinner-border text-danger"
                                    role="status"
                                  >
                                    <span className="sr-only"></span>
                                  </div>
                                </div>
                              ) : (
                                <React.Fragment>
                                  <p className="label_text">
                                    Click or drag <br /> and drop file
                                  </p>
                                  <img
                                    className="img-fluid"
                                    src={uploadArrow}
                                    alt=""
                                  />
                                </React.Fragment>
                              )}
                            </div>
                            <input
                              onChange={(e) => handleFileUpload(e, "image")}
                              id="inputTagImage"
                              className="input-file-type"
                              type="file"
                              name="file"
                              accept="image/png, image/jpg, image/jpeg"
                            />
                          </label>
                        </div>
                      </div>
                    ) : (
                      <div className="col-md-6">
                        <div className="img-upload-success-div">
                          <div className="close-icon-signature-div">
                            <div className="close-icon-img cursor-pointer">
                              <img
                                src={closeIcon}
                                onClick={() => clearImage("image")}
                              ></img>
                            </div>
                            <div className="signature-img-div">
                              {pictureImageUrl.length > 0 && (
                                <img
                                  src={DOMPurify.sanitize(pictureImageUrl)}
                                  width="70%"
                                  height="120px"
                                  style={{ zIndex: 1, margin: "auto" }}
                                ></img>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* ------ */}

                    {!signatureImageUrl ? (
                      <React.Fragment>
                        <div className="col-xl-3">
                          <div className="col-md-3">
                            <label
                              htmlFor="firstname"
                              className="label_text2 text-nowrap"
                            >
                              Draw/upload signature
                            </label>
                            <label
                              className="cursor-pointer"
                              htmlFor="inputTagSignature"
                            >
                              <div className="pic_upload d-flex justify-content-between pt-3 pr-3 px-2">
                                {settingSignatureImage ? (
                                  <div className="center-v">
                                    <div
                                      className="spinner-border text-danger"
                                      role="status"
                                    >
                                      <span className="sr-only"></span>
                                    </div>
                                  </div>
                                ) : (
                                  <React.Fragment>
                                    <p className="label_text">
                                      Click or drag <br /> and drop file
                                    </p>
                                    <img
                                      className="img-fluid"
                                      src={uploadArrow}
                                      alt=""
                                    />
                                  </React.Fragment>
                                )}
                              </div>
                              <input
                                onChange={(e) =>
                                  handleFileUpload(e, "signature")
                                }
                                id="inputTagSignature"
                                className="input-file-type"
                                type="file"
                                name="file"
                                accept="image/png, image/jpg, image/jpeg"
                              />
                            </label>
                          </div>
                        </div>

                        <div className="col-xl-3">
                          <div className="col-md-3 mt-4">
                            <div
                              className="pic_upload d-flex justify-content-between pt-3 pr-3 px-2"
                              onClick={() =>
                                toggleSignaturePad("signature", true)
                              }
                            >
                              <p className="label_text">
                                Draw an <br /> e-signature
                              </p>
                              <img className="img-fluid" src={pen} alt="" />
                            </div>
                          </div>
                        </div>
                      </React.Fragment>
                    ) : (
                      <div className="col-md-6">
                        <div className="img-upload-success-div">
                          <div className="close-icon-signature-div">
                            <div className="close-icon-img cursor-pointer">
                              <img
                                src={closeIcon}
                                onClick={() => clearImage("signature")}
                              ></img>
                            </div>
                            <div className="signature-img-div">
                              {signatureImageUrl.length > 0 && (
                                <img
                                  src={DOMPurify.sanitize(signatureImageUrl)}
                                  width="70%"
                                  height="120px"
                                ></img>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="row">
                    {!frontPageImageUrl ? (
                      <div className="col-md-6">
                        <div className="col-md-6 mt-4">
                          <label
                            htmlFor="firstname"
                            className="label_text2 d-inline text-nowrap"
                          >
                            Upload valid ID
                          </label>
                          <label
                            className="cursor-pointer"
                            htmlFor="inputTagFrontPageId"
                          >
                            <div className="pic_upload2 d-flex justify-content-between font-weight-bold pt-3 pr-3 px-2">
                              {settingFrontPageImage ? (
                                <div className="center-v">
                                  <div
                                    className="spinner-border text-danger"
                                    role="status"
                                  >
                                    <span className="sr-only"></span>
                                  </div>
                                </div>
                              ) : (
                                <React.Fragment>
                                  <p className="label_text">
                                    Click or drag <br /> and drop file
                                  </p>
                                  <img
                                    className="img-fluid"
                                    src={uploadArrow}
                                    alt=""
                                  />
                                </React.Fragment>
                              )}
                            </div>
                            <input
                              onChange={(e) =>
                                handleFileUpload(e, "frontPageId")
                              }
                              id="inputTagFrontPageId"
                              className="input-file-type"
                              type="file"
                              accept="image/png, image/jpg, image/jpeg"
                            />
                          </label>
                        </div>
                      </div>
                    ) : (
                      <div className="col-md-6">
                        <div className="img-upload-success-div">
                          <div className="close-icon-signature-div">
                            <div className="close-icon-img cursor-pointer">
                              <img
                                src={closeIcon}
                                onClick={() => clearImage("front-page")}
                              ></img>
                            </div>
                            <div className="signature-img-div">
                              {frontPageImageUrl.length > 0 && (
                                <img
                                  src={DOMPurify.sanitize(frontPageImageUrl)}
                                  width="70%"
                                  height="120px"
                                  style={{ zIndex: 1, margin: "auto" }}
                                ></img>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  <label
                    htmlFor="branch domicilation"
                    className="label_text my-4 col"
                  >
                    Select value-added services
                  </label>

                  <div className="row">
                    <div className="col-md-3 mr-5">
                      <div className="custom-control custom-checkbox input-group mb-2">
                        <input
                          name="smsAlertValueAddedService"
                          onChange={formik.handleChange}
                          value={formik.values.smsAlertValueAddedService}
                          type="checkbox"
                          className="custom-control-input"
                          id="checkbox1"
                          checked
                        />
                        <label
                          className="custom-control-label pl-3 text-nowrap"
                          htmlFor="checkbox1"
                        >
                          SMS alert
                        </label>
                      </div>
                    </div>
                    <div className="col-md-3 ml-5">
                      <div className="custom-control custom-checkbox checkbox-lg border-dark input-group mb-2">
                        <input
                          name="emailAlertValueAddedService"
                          onChange={formik.handleChange}
                          value={formik.values.emailAlertValueAddedService}
                          type="checkbox"
                          className="custom-control-input"
                          id="checkbox2"
                          checked
                        />
                        <label
                          className="custom-control-label pl-2 text-nowrap"
                          htmlFor="checkbox2"
                        >
                          Email alert
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="col">
                    <div className="custom-control custom-checkbox checkbox-lg input-group mb-2 ">
                      <input
                        name="debitCardValueAddedService"
                        onChange={formik.handleChange}
                        value={formik.values.debitCardValueAddedService}
                        type="checkbox"
                        className="custom-control-input"
                        id="checkbox3"
                      />
                      <label
                        className="custom-control-label pl-3"
                        htmlFor="checkbox3"
                      >
                        <b>
                          Debit card (Verve/Mastercard) - Click here, if you do
                          not want a debit card
                        </b>
                      </label>
                    </div>
                  </div>

                  {!formik.values.debitCardValueAddedService && (
                    <div className="row container" id="dvPassport">
                      <div className="col-md-3 form-group">
                        <div className="custom-control custom-radio input-group mb-2">
                          <input
                            name="debitCardType"
                            onChange={formik.handleChange}
                            value="verve"
                            type="radio"
                            className="custom-control-input debit-card-radio-input"
                            id="rad1"
                            checked={formik.values.debitCardType === "verve"}
                          />
                          <label
                            className="custom-control-label pl-3"
                            htmlFor="rad1"
                          >
                            Verve
                          </label>
                        </div>
                      </div>
                      <div className="col-md-4 mb-4">
                        <div className="custom-control custom-radio input-group mb-2">
                          <input
                            name="debitCardType"
                            onChange={formik.handleChange}
                            value="master_card"
                            type="radio"
                            className="custom-control-input debit-card-radio-input"
                            id="rad2"
                            checked={
                              formik.values.debitCardType === "master_card"
                            }
                          />
                          <label
                            className="custom-control-label pl-3"
                            htmlFor="rad2"
                          >
                            MasterCard
                          </label>
                        </div>
                      </div>
                      <div className="col-md-5 mt-n3">
                        <div className="bvn_val mb-2 " id="fader">
                          <img src={Icon_L} alt="" />
                          <small className="text-danger ml-3 text-nowrap">
                            . The card will be delivered to <br /> your
                            residential address
                          </small>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <div
                  className="tab-pane fade"
                  id="pills-no"
                  role="tabpanel"
                  aria-labelledby="pills-no-tab"
                >
                  <label
                    htmlFor="branch domicilation"
                    className="label_text mt-3 mb-3 col"
                  >
                    Select value-added services
                  </label>

                  <div className="row">
                    <div className="col-md-3 mr-5">
                      <div className="custom-control custom-checkbox input-group mb-2">
                        <input
                          name="smsAlertValueAddedService"
                          onChange={formik.handleChange}
                          value={formik.values.smsAlertValueAddedService}
                          type="checkbox"
                          className="custom-control-input"
                          id="checkbox4"
                          checked
                        />
                        <label
                          className="custom-control-label pl-3 text-nowrap"
                          htmlFor="checkbox4"
                        >
                          SMS alert
                        </label>
                      </div>
                    </div>
                    <div className="col-md-3 ml-5">
                      <div className="custom-control custom-checkbox checkbox-lg border-dark input-group mb-2">
                        <input
                          name="emailAlertValueAddedService"
                          onChange={formik.handleChange}
                          value={formik.values.emailAlertValueAddedService}
                          type="checkbox"
                          className="custom-control-input"
                          id="checkbox5"
                          checked
                        />
                        <label
                          className="custom-control-label pl-2 text-nowrap"
                          htmlFor="checkbox5"
                        >
                          Email alert
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="col">
                    {/* <div className="custom-control custom-checkbox checkbox-lg input-group mb-2 ">
                        <input type="checkbox" className="custom-control-input" id="checkbox6" onclick="ShowHideDiv(this)" />
                        <label className="custom-control-label pl-3" htmlFor="checkbox6">Debit card</label>
                      </div> */}
                    <div className="custom-control custom-checkbox checkbox-lg input-group mb-2 ">
                      <input
                        name="debitCardValueAddedService"
                        onChange={formik.handleChange}
                        value={formik.values.debitCardValueAddedService}
                        type="checkbox"
                        className="custom-control-input"
                        id="checkbox6"
                      />
                      <label
                        className="custom-control-label pl-3"
                        htmlFor="checkbox6"
                      >
                        <b>
                          Debit card (Verve/Mastercard) - Click here, if you do
                          not want a debit card
                        </b>
                      </label>
                    </div>
                  </div>

                  <div className="row container verve-div mb-3" id="dvPassport">
                    <div className="col-md-3 form-group">
                      <div className="custom-control custom-radio input-group mb-2">
                        <input
                          type="radio"
                          className="custom-control-input"
                          id="rad1"
                          value=""
                        />
                        <label
                          className="custom-control-label pl-3"
                          htmlFor="rad1"
                        >
                          Verve
                        </label>
                      </div>
                    </div>
                    <div className="col-md-3 mb-4">
                      <div className="custom-control custom-radio input-group mb-2">
                        <input
                          type="radio"
                          className="custom-control-input"
                          id="rad2"
                        />
                        <label
                          className="custom-control-label pl-3"
                          htmlFor="rad2"
                        >
                          MasterCard
                        </label>
                      </div>
                    </div>
                    <div className="col-md-6 mt-n3">
                      <div className="bvn_val mb-4 " id="fader">
                        <img src="./images/Icon (L).svg" alt="" />
                        <small className="text-danger ml-3 text-nowrap">
                          . The card will be delivered to <br /> your
                          residential address
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row container mt-5 ml-0">
              <div className="custom-control custom-checkbox checkbox-lg input-group mb-2">
                <input
                  name="terms"
                  onChange={formik.handleChange}
                  value={formik.values.terms}
                  type="checkbox"
                  className="custom-control-input"
                  id="checkbox4"
                />
                <label
                  className="custom-control-label pl-3"
                  htmlFor="checkbox5"
                >
                  By checking this box, you have accepted the{" "}
                  <span>
                    <a
                      className="text-danger cursor-pointer"
                      href={links.termsAndConditionsPDF}
                      target="_blank"
                    >
                      <u>Terms and conditions</u>
                    </a>
                  </span>
                </label>
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-end mt-2">
            <div className="mb-3 mr-4" style={{ marginRight: "20px" }}>
              <button
                onClick={() => {
                  goToStep("update-detail");
                }}
                className="btn btn-outline-danger mr-3 btn-filled-white"
              >
                Previous
              </button>
            </div>
            {updating ? (
              <div className="spinner-border text-danger" role="status">
                <span className="sr-only"></span>
              </div>
            ) : (
              <button type="submit" className="btn btn-danger btn-filled-red">
                Proceed
              </button>
            )}
          </div>
        </div>
      </form>
    </div>
  );
}

export default ExUploadDocumentJointCurrentDialog;
